import React from 'react';
import loadable from '@loadable/component';
import AnimatedLoader from 'components/BelowTheFoldControl/AnimatedLoader';


export default loadable(
  () => import(/* webpackChunkName: "prices-revealed" */ './PricesRevealed'),
  {
    fallback: <AnimatedLoader />,
  },
);
